import { DeleteOrgMemberRequestSchema, DeleteOrgMemberResponseSchema } from './delete-org-member.schema';
/**
 * Delete Org Member Endpoint Contract
 * Deletes an organization member by ID
 */ export const deleteOrgMemberContract = {
    method: 'DELETE',
    path: '/api/v2/org-member/:id',
    description: 'Delete an organization member by ID',
    requestSchema: DeleteOrgMemberRequestSchema,
    responseSchema: DeleteOrgMemberResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Organization member not found'
        }
    }
};

//# sourceMappingURL=delete-org-member.contract.js.map